import { useContext } from 'react'
import { useDispatch } from 'react-redux'
import useQuery from '@cbgms/base/http/use-query'
import { VehicleProvider } from '@cbgms/api'
import { ShopCountry } from '@cbgms/base/shop-id'
import { LocaleContext } from '@cbgms/base/locale/LocaleContext'
import { loadTypes } from 'app/vehicles/state/actions'
import { useGetTypesCacheKey } from './cacheKeys'

export const useGetTypes = (provider: VehicleProvider, country: ShopCountry, brandKey?: string, modelKey?: string) => {
  const dispatch = useDispatch()
  const { locale } = useContext(LocaleContext)

  return useQuery(
    useGetTypesCacheKey(provider, country, brandKey, modelKey),
    async () => {
      const { Data } = await dispatch(loadTypes(brandKey || '', modelKey || '', locale, country, provider))
      return Data
    },
    { enabled: !!brandKey && !!modelKey, staleTime: 2 * 60 * 1000 }
  )
}
